import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

// A conversation seed handed to ChatPage through router state. ChatPage does a
// get-or-create keyed by `seedKey` (so re-clicking the same card reopens its
// existing chat), gives a new one `title` as its heading, posts `briefing` as a
// hidden first message (kept out of the visible transcript), and immediately
// streams — so the first thing the user sees is Zeph's own opening message.
// `hubspotUrl`, when set, drives the "Open in HubSpot" button on the chat screen.
export type ZephChatSeed = {
  // Stable per-source id, e.g. `hubspot-task:<id>` / `hubspot-ticket:<id>`. One
  // conversation per key, per user.
  seedKey: string
  title: string
  briefing: string
  hubspotUrl?: string | null
}

/**
 * Start a Zeph conversation from anywhere in the dashboard. Navigates to the chat
 * page; ChatPage picks the seed up from router state and builds the conversation.
 */
export function useStartZephChat() {
  const navigate = useNavigate()
  return useCallback(
    (seed: ZephChatSeed) => {
      navigate('/dashboard/chat', { state: { zephSeed: seed } })
    },
    [navigate],
  )
}
